import { AnyAction } from "redux"

export interface IPrinterData {
    printerID: number | null
    formatID: number | null
    scales: number | null
    entryFormat: number | null
    /** ZPL ChangeInternationalEncodingZPL: 36 — дефолт, также 28 и 0. */
    encoding: number
    isOpen: boolean
}

export const DEFAULT_ENCODING = 36

const initialState: IPrinterData = {
    printerID: null,
    formatID: null,
    isOpen: false,
    scales: 0,
    entryFormat: null,
    encoding: DEFAULT_ENCODING
}

export const SET_PRINTER_ID = 'SET_PRINTER_ID'
export const SET_FORMAT_ID = 'SET_FORMAT_ID'
export const SET_IS_OPEN = 'SET_IS_OPEN'
export const CLEAR_PRINTER_STATE = 'CLEAR_PRINTER_STATE'
export const SET_SCALES = 'SET_SCALES'
export const SET_ENTRY_FORMAT = 'SET_ENTRY_FORMAT'
export const SET_ENCODING = 'SET_ENCODING'
/**
 * Слайс восстанавливается из localStorage (см. store.js), и у клиентов,
 * сохранивших состояние до появления encoding, поля в нём нет — дефолт из
 * initialState в этом случае не применяется. Новый объект создаём только когда
 * поле действительно отсутствует: слайс селектят целиком, и безусловная копия
 * ломала бы референсное равенство в useSelector на каждом экшене приложения.
 */
const withDefaults = (state: IPrinterData): IPrinterData =>
    typeof state.encoding === 'number' ? state : { ...initialState, ...state }

const printerReducer = (state = initialState, action: AnyAction): IPrinterData => {
    const prev = withDefaults(state)
    switch(action.type) {
        case SET_PRINTER_ID:
            return {
                ...prev,
                printerID: action.payload
            }

        case SET_FORMAT_ID:
            return {
                ...prev,
                formatID: action.payload
            }
            
        case SET_SCALES:
            return {
                ...prev,
                scales: action.payload
            }
        case SET_ENTRY_FORMAT:
            return {
                ...prev,
                entryFormat: action.payload
            }
        case SET_ENCODING:
            return {
                ...prev,
                encoding: action.payload
            }
        case SET_IS_OPEN:
            return {
                ...prev,
                isOpen: action.payload
            }

        case CLEAR_PRINTER_STATE:
            return initialState
              
        default: return prev
    }
}

export default printerReducer